import type { DashboardAdvice } from '../api/dashboard'
import { hrefOf } from '../overview/href'
import './DashboardAdvice.css'

/**
 * Caseta de sfat, ca version-3/dashboard/advice.php. Classic view nu intra.
 *
 * -----------------------------------------------------------------------------
 * O BANDA DEASUPRA GRILEI, NU UN LOC IN EA
 * -----------------------------------------------------------------------------
 *
 * Pana pe 18 septembrie 2026 sfatul statea in grila, intr-un loc de o celula
 * fixat pe coloana 4, randul 1 (`odb-placed`, `--gx: 4; --gy: 1`). Doua urmari,
 * amandoua vazute pe `optimumdesk.ai`:
 *
 *   - ce scrie sfatul nu incape intr-o celula. Are un rand pentru FIECARE card
 *     peste limita si pentru FIECARE card necitit, si nicio regula nu-l taia:
 *     `.odb-slot > .odb-card` se potriveste numai pe `.odb-card`, iar foaia
 *     cutiei lui plecase odata cu caseta din portal (sfatul e acolo la
 *     clopotel). Masurat in Edge la 1440x900, cu patru carduri peste limita si
 *     cinci necitite: randurile ieseau cu 304px sub celula, scrise peste
 *     cardul de dedesubt;
 *   - pe un tablou aranjat de mana (`x`/`y` din `it_dashboard_board_cards`),
 *     constructorul nu stie de locul sfatului. Un card pus pe x=3, y=0 era
 *     asezat fix peste el - doua elemente cu loc explicit in aceeasi celula,
 *     pe care grila le suprapune fara sa se planga.
 *
 * Sfatul e despre TABLOU, nu despre o cifra (vezi capul sectiunii "CE SA FACI
 * INTAI" din `od_dashboard.css`), deci sta deasupra grilei, cat ii trebuie, si
 * grila ramane numai a cardurilor.
 */
export function DashboardAdviceBand({ advice }: { advice: DashboardAdvice }) {
  return (
    <div className={`odb-advice odb-advice-band odb-t-${advice.tone}`} id="odbAdvice">
      <div className="odb-advice-head">
        <span className="odb-advice-mark">
          <i className="fas fa-bolt" aria-hidden="true"></i>
        </span>
        <b className="odb-advice-headline">{advice.headline}</b>
      </div>
      {advice.lines.length > 0 && (
        <ul className="odb-advice-lines">
          {advice.lines.map((line, i) => (
            <li className={`odb-advice-line odb-t-${line.tone}`} key={i}>
              <i className={`fas ${line.icon}`} aria-hidden="true"></i>
              {/* Sfatul primeste adresa de catalog, scrisa ca in portal. `hrefOf` o
                  duce in /app cand ecranul e deja acolo: altfel clicul iese din
                  aplicatie ca sa fie intors imediat cu 302. */}
              {line.url !== '' ? <a href={hrefOf(line.url) ?? '/' + line.url.replace(/^\//, '')}>{line.text}</a> : <span>{line.text}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
